import { Collection } from "@datx/core";
import { jsonapi } from "@datx/jsonapi";
import LoadStatus from "../models/loadStatus";
import Survey from "../models/survey";

export default class SurveyStore extends jsonapi(Collection) {
  static types = [Survey, LoadStatus];
  
}